import React from "react";
import "./Pills.scss";

type Variant =
  | "primary"
  | "success"
  | "danger"
  | "warning"
  | "ghost"
  | "secondary";

interface PillsProps {
  label: string;
  variant?: Variant;
  size?: "sm" | "md";
  className?: string;
}

const Pills: React.FC<PillsProps> = ({
  label,
  variant = "primary",
  size = "md",
  className = "",
}) => {
  const classes = [
    "cg-pill",
    `cg-pill--${variant}`,
    `cg-pill--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return <span className={classes}>{label}</span>;
};

export default Pills;
